import { useMutation } from '@tanstack/react-query';
import { operations } from '@/generated/supplier-experience-api';
import apiClient from '@/lib/apiClient';

export type CreateBankAccountLinkTokenResponse =
  operations['createSupplierIntegrationLinkToken']['responses'][201]['content']['application/json'];

export type CreateBankAccountLinkTokenBody =
  operations['createSupplierIntegrationLinkToken']['requestBody']['content']['application/json'];

const useCreateBankAccountLinkToken = () => {
  return useMutation({
    mutationKey: ['createBankAccountLinkToken'],
    mutationFn: (body: CreateBankAccountLinkTokenBody) => {
      return apiClient
        .post('api/supplier-experience/bank-accounts/link-token', { json: body })
        .json<CreateBankAccountLinkTokenResponse>();
    },
  });
};

export default useCreateBankAccountLinkToken;
